module.exports = __webpack_public_path__ + "img/Billionaire-5.9d8fd78a.gif";